import React from 'react';
import back2 from '../client-portal-images/back2.png';

// Full-page background at original clarity (no dulling overlay), with a
// "CLIENT" label blended onto the left side of the photo so the page reads
// as the client's dedicated portal at a glance.
const AuthBackgroundLayout = ({ children }) => (
  <div style={{ position: 'relative', minHeight: '100vh' }}>
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        backgroundImage: `url(${back2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
    <div
      style={{
        position: 'fixed',
        left: '4%',
        top: '50%',
        transform: 'translateY(-50%) rotate(-2deg)',
        zIndex: 0,
        fontFamily: "'Arial Black', Arial, sans-serif",
        fontWeight: 900,
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        letterSpacing: '0.15em',
        color: 'rgba(255,255,255,0.55)',
        textShadow: '0 2px 10px rgba(0,0,0,0.35), 0 0 1px rgba(0,0,0,0.5)',
        mixBlendMode: 'overlay',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      CLIENT
    </div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      {children}
    </div>
  </div>
);

export default AuthBackgroundLayout;
